import React, { useEffect, useState } from 'react';
import { adminOverview, errMsg } from './aiPaperApi';
import { fmtSize } from './FileTable';
import TeacherDetail from './TeacherDetail';
import { ui } from './ui';

const th = { textAlign: 'left', padding: '8px 10px', fontSize: 12, color: '#3730a3', background: '#eef2ff', whiteSpace: 'nowrap' };
const td = { padding: '7px 10px', fontSize: 13, borderTop: '1px solid #e2e8f0' };
const fmt = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-');
const Tile = ({ label, value, color }) => (
  <div style={{ flex: '1 1 130px', background: '#fff', border: `2px solid ${color}`, borderRadius: 12, padding: 12, textAlign: 'center' }}>
    <div style={{ fontSize: 28, fontWeight: 900, color }}>{value}</div>
    <div style={{ fontSize: 12, fontWeight: 700, color: '#475569' }}>{label}</div>
  </div>
);

// Principal/Admin: centralized analytics with a teacher-wise breakdown.
function PrincipalPaperMonitor({ user, onClose }) {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => { adminOverview(user).then(setData).catch((e) => setErr(errMsg(e))); }, [user]);

  const max = Math.max(1, ...(data?.last30Days || []).map((d) => d.count));
  return (
    <div style={ui.overlay}>
      <div style={ui.panel}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h2 style={{ margin: 0, color: '#312e81', fontSize: 21, fontWeight: 900 }}>📈 Paper Generation Monitor</h2>
          <button style={ui.btnDanger} onClick={onClose}>Close</button>
        </div>
        {err && <div style={ui.errorBox}>{err}</div>}
        {!data ? <div>Loading…</div> : (
          <>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
              <Tile label="Papers Generated" value={data.totals.papers} color="#4f46e5" />
              <Tile label="Source Files" value={data.totals.files} color="#059669" />
              <Tile label="Downloads" value={data.totals.downloads} color="#d97706" />
              <Tile label="Teachers Active" value={data.totals.activeTeachers} color="#be185d" />
            </div>
            {data.last30Days.length > 0 && (
              <div style={{ ...ui.card, marginBottom: 14 }}>
                <div style={{ fontWeight: 800, fontSize: 13, color: '#3730a3', marginBottom: 6 }}>Papers generated – last 30 days</div>
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 70 }}>
                  {data.last30Days.map((d) => (
                    <div key={d.date} title={`${d.date}: ${d.count}`} style={{ flex: 1, minWidth: 4, height: `${(d.count / max) * 100}%`, background: '#6366f1', borderRadius: 3 }} />
                  ))}
                </div>
              </div>
            )}
            <div style={{ overflowX: 'auto', border: '1px solid #e2e8f0', borderRadius: 10 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 620 }}>
                <thead><tr>
                  <th style={th}>Teacher</th><th style={th}>Papers</th><th style={th}>Files</th><th style={th}>Storage</th>
                  <th style={th}>Downloads</th><th style={th}>Last active</th><th style={th} />
                </tr></thead>
                <tbody>
                  {data.teachers.map((t) => (
                    <tr key={t.key} style={{ background: sel?.key === t.key ? '#eef2ff' : '#fff' }}>
                      <td style={{ ...td, fontWeight: 700 }}>{t.teacherName}</td>
                      <td style={td}>{t.papers}</td><td style={td}>{t.files}</td><td style={td}>{fmtSize(t.bytes)}</td>
                      <td style={td}>{t.downloads}</td><td style={td}>{fmt(t.lastActive)}</td>
                      <td style={td}><button style={ui.btnSmall} onClick={() => setSel(t)}>View details</button></td>
                    </tr>
                  ))}
                  {data.teachers.length === 0 && <tr><td style={td} colSpan={7}>No activity recorded yet.</td></tr>}
                </tbody>
              </table>
            </div>
          </>
        )}
        {sel && <TeacherDetail user={user} teacher={sel} />}
      </div>
    </div>
  );
}

export default PrincipalPaperMonitor;
